import { SortDirection } from "@mui/material/TableCell";

import { ArrowDownIcon, ArrowUpIcon } from "components/Icons";
import Spinner from "components/Spinner";

import styles from "./styles.module.scss";

export const ORDER_ASC = "asc";
export const ORDER_DESC = "desc";

interface IIconSort {
  rowId: string;
  order?: SortDirection;
  orderBy?: string | null;
  isLoading?: boolean;
}

export default function IconSortComponent(props: IIconSort) {
  const { rowId, order, orderBy, isLoading } = props;

  return (
    <div className={styles.sortIconWrap}>
      {isLoading ? (
        orderBy === rowId && <Spinner size={14} />
      ) : (
        <>
          <ArrowUpIcon
            id="sortAsc"
            className={
              orderBy === rowId &&
              `${order}`.toUpperCase() === ORDER_ASC.toUpperCase()
                ? styles.sortIconActive
                : styles.sortIcon
            }
          />
          <ArrowDownIcon
            id="sortDesc"
            className={
              orderBy === rowId &&
              `${order}`.toUpperCase() === ORDER_DESC.toUpperCase()
                ? styles.sortIconActive
                : styles.sortIcon
            }
          />
        </>
      )}
    </div>
  );
}
